import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
export function Hero() {
  const navigate = useNavigate();
  const locations = [{
    id: 'annapolis',
    name: 'Jennifer Rd, Annapolis, MD',
    address: '2002 Jennifer Rd, Annapolis, MD 21401'
  }, {
    id: 'dc',
    name: 'Pennsylvania Avenue, Washington, D.C.',
    address: '1234 Pennsylvania Ave NW, Washington, D.C. 20004'
  }];
  return <section className="relative py-12 sm:py-16 lg:py-24 border-b border-slate-100 overflow-hidden" data-id="element-144">
      {/* Background Image */}
      <motion.div initial={{
      scale: 1.1,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute inset-0 z-0" data-id="element-145">
        <img src="https://cdn.magicpatterns.com/uploads/qCDJanuqP7AjhZnRF6Mqoy/ChatGPT_Image_May_19,_2026,_02_27_47_AM.png" alt="Daily Care Pharmacy Storefront" className="w-full h-full object-cover" data-id="element-146" />
        <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]" data-id="element-147"></div>
      </motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="text-center mb-12 sm:mb-16 bg-slate-900/20 backdrop-blur-md py-10 px-6 rounded-3xl border border-white/10 max-w-3xl mx-auto" data-id="element-149">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight mb-4 drop-shadow-xl" data-id="element-150">
            Welcome to Your Local Digital Pharmacy.
          </h1>
          <p className="text-white text-base sm:text-lg font-medium drop-shadow-md" data-id="element-151">
            Select a location to start your journey.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-152">
          {locations.map((loc, idx) => <motion.div key={idx} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.4 + idx * 0.1,
          duration: 0.6
        }} className="bg-white border-2 border-slate-100 rounded-xl p-6 sm:p-8 hover:border-clinical-blue transition-all group" data-id="element-153">
              <div className="flex items-center gap-3 mb-6" data-id="element-154">
                <div className="w-10 h-10 bg-clinical-blue/5 rounded-full flex items-center justify-center text-clinical-blue" data-id="element-155">
                  <MapPinIcon className="w-5 h-5" data-id="element-156" />
                </div>
                <h3 className="text-lg font-bold text-slate-900" data-id="element-157">{loc.name}</h3>
              </div>
              <p className="text-slate-500 text-sm mb-8 leading-relaxed" data-id="element-158">
                {loc.address}
              </p>
              <button onClick={() => navigate(`/otc-products/${loc.id}`)} className="w-full bg-clinical-blue text-white font-bold py-4 rounded-lg hover:bg-blue-700 transition-colors uppercase tracking-wider text-xs" data-id="element-159">
                Select This Store
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}